/**
 * @deprecated use same function from '@rchh/lowcode-utils' instead
 */
export function isActionContentObject(obj) {
  return obj && typeof obj === 'object';
}